import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import VendorHierarchyTree from '../component/VendorHierarchyTree';

class VendorHierarchyList extends Component {
    componentDidMount() {
        this.loadHierarchyTree();
    }

    loadHierarchyTree = () => {
        this.props.getVendorHierarchyTree({}, () => { });
    }

    render() {
        const { getVendorRoomService = {} } = this.props;
        const { isLoading, vendorHierarchyTreeData } = getVendorRoomService;

        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0 hierarchy-page">
                        <Header />
                        <div className="hierarchy-page-header px-3 pt-3 d-flex flex-wrap align-items-start justify-content-between gap-2">
                            <div>
                                <h4 className="mb-1">Hierarchy Level</h4>
                                <p className="text-muted mb-0">
                                    View ward, room, and nurse structure — Room based or Staff based.
                                </p>
                            </div>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={this.loadHierarchyTree}
                                disabled={!!isLoading}
                            >
                                <i className="fas fa-sync-alt me-1" aria-hidden="true" />
                                Refresh
                            </button>
                        </div>
                        <div className="hierarchy-page-scroll px-3 pb-4">
                            <VendorHierarchyTree treeData={vendorHierarchyTreeData} />
                        </div>
                    </div>
                </div>
                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => ({
    getVendorRoomService: Actions.getVendorRoomService(state),
});

export default withRouter(connect(mapStateToProps, {
    getVendorHierarchyTree: Actions.getVendorHierarchyTree,
})(VendorHierarchyList));
